import { render, staticRenderFns } from "./DictList.vue?vue&type=template&id=3d05f366&scoped=true"
import script from "./DictList.vue?vue&type=script&lang=js"
export * from "./DictList.vue?vue&type=script&lang=js"
import style0 from "./DictList.vue?vue&type=style&index=0&id=3d05f366&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d05f366",
  null
  
)

export default component.exports